import { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { OrderQuery } from '../../../../../../services/query';
import Swal from 'sweetalert2';
import Clear from '../../../../../../assets/icons/svg/icons/clear.svg';
import Package from '../../../../../../assets/icons/svg/icons/package.svg';
import TextsmsIcon from '@mui/icons-material/Textsms';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import {
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Grid,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import TimeHelper from '../../../../../../utils/time';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import EventIcon from '@mui/icons-material/Event';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CopyToClipboardButton from '@/atomic/atoms/SCUICopyToClipboardButton/SCUICopyToClipboardButton';
import { UCPD } from './userCargoPackageDetails.classes';

const resolveShipmentEstimatedDeliveryMessage = (orderInformation: any, shipment: any) => {
    if (!orderInformation) {
        return null;
    }

    const orderShipmentDetails = orderInformation.orderShipmentDetails;
    if (!Array.isArray(orderShipmentDetails)) {
        return null;
    }

    const nestedShipments = orderShipmentDetails.flatMap(
        (detail: any) => (Array.isArray(detail?.shipments) ? detail.shipments : [])
    );

    const matchedShipment =
        nestedShipments.find(
            (item: any) =>
                item?.shipmentId === shipment?.shippingListId ||
                item?.shipmentNumber === shipment?.shippingListNo ||
                String(item?.shipmentNumber) === String(shipment?.shippingListNo)
        ) ?? nestedShipments[0];

    return matchedShipment?.shipmentDetail?.shipmentEstimatedDeliveryMessage ?? null;
};

function UserCargoPackageDetails({ shipment, orderInformation }: any) {
    const { t } = useTranslation();
    const [data, setData] = useState<any>(null);
    const [cargoLoading, setCargoLoading] = useState(true);
    const shipmentEstimatedDeliveryMessage = resolveShipmentEstimatedDeliveryMessage(
        orderInformation,
        shipment
    );

    useEffect(() => {
        if (shipment.shippingListId) {
            let req = { shippingId: shipment.shippingListId };
            OrderQuery.GetShippingListPackageDetail(req)
                .then((res) => {
                    if (res) {
                        setData(res);
                    }
                })
                .finally(() => {
                    setCargoLoading(false);
                });
        } else {
            Swal.fire('Shipment Bulunamadı');
        }
    }, []);

    return (
        <>
            {(shipment?.estimatedShippedDate ||
                shipment.lostPackageModel ||
                shipmentEstimatedDeliveryMessage ||
                shipment.isSellerStore) && (
                <Card
                    className={UCPD.metaCard}
                    sx={{
                        minWidth: 275,
                        margin: 2,
                        border: '1px solid #ccc',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        backgroundColor: '#f9f9f9',
                    }}
                >
                    <CardContent className={UCPD.metaContent}>
                        {shipment.estimatedShippedDate && (
                            <div
                                className={UCPD.rowEstimatedShipDate}
                                style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}
                            >
                                <LocalShippingIcon style={{ width: '20px', height: '20px', color: 'orange' }} />
                                <Typography variant="body1" style={{ marginLeft: '1rem', fontWeight: 'bold' }}>
                                    {t('orderDetail.estimatedShippingDate')}:
                                </Typography>
                                <Typography variant="body1" style={{ marginLeft: '1rem', fontWeight: 'bold' }}>
                                    {TimeHelper.formatDate(shipment.estimatedShippedDate)}
                                </Typography>
                            </div>
                        )}
                        {shipmentEstimatedDeliveryMessage && (
                            <div
                                className={UCPD.rowEstimatedRange}
                                style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}
                            >
                                <EventIcon style={{ width: '20px', height: '20px', color: 'orange' }} />
                                <Typography
                                    variant="body1"
                                    style={{ marginLeft: '1rem', fontWeight: 'bold' }}
                                    dangerouslySetInnerHTML={{ __html: shipmentEstimatedDeliveryMessage }}
                                />
                            </div>
                        )}
                        {true && (
                            <div
                                className={UCPD.rowLostPackage}
                                style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}
                            >
                                {(shipment.lostPackageModel.invoicedToCompanyMessage ||
                                    shipment?.lostPackageModel?.message) && (
                                    <>
                                        <Typography
                                            variant="body1"
                                            style={{ marginLeft: '1rem', fontWeight: 'bold', color: '#0288d1' }}
                                        >
                                            <a
                                                className={UCPD.inputLinkLostPackageOrder}
                                                href={`/orderdetail?shippingListId=${
                                                    shipment.shippingListId ===
                                                    shipment.lostPackageModel.customerShippingListId
                                                        ? shipment.lostPackageModel.companyShippingListId
                                                        : shipment.lostPackageModel.customerShippingListId
                                                }`}
                                                target="_blank"
                                                style={{ textDecoration: 'none', color: '#0288d1' }}
                                                onMouseEnter={(e) =>
                                                    (e.currentTarget.style.textDecoration = 'underline')
                                                }
                                                onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')}
                                                rel="noreferrer"
                                            >
                                                {shipment.lostPackageModel.message}
                                            </a>
                                        </Typography>
                                        {shipment.lostPackageModel.invoicedToCompanyMessage && (
                                            <Typography
                                                className={UCPD.lostPackageInvoicedMessage}
                                                variant="body1"
                                                style={{ marginLeft: '0.5rem', fontWeight: 'bold', color: 'red' }}
                                            >
                                                ({shipment.lostPackageModel.invoicedToCompanyMessage})
                                            </Typography>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                        {shipment.isSellerStore && (
                            <div
                                className={UCPD.rowSellerStoreTracking}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'start',
                                    alignItems: 'center',
                                    marginTop: '0.5rem',
                                }}
                            >
                                <LocalOfferIcon style={{ width: '20px', height: '20px', color: 'orange' }} />
                                <Typography variant="body1" style={{ marginLeft: '1rem', fontWeight: 'bold' }}>
                                    {t('general.mpCargoShipmentNo')}:
                                </Typography>
                                <Typography variant="body1" style={{ marginLeft: '1rem', fontWeight: 'bold' }}>
                                    {shipment.trackingCode || '-'}
                                </Typography>
                                {shipment.trackingCode && (
                                    <span className={UCPD.copyTrackingWrap}>
                                        <CopyToClipboardButton textToCopy={shipment.trackingCode} />
                                    </span>
                                )}
                            </div>
                        )}
                    </CardContent>
                </Card>
            )}

            {data ? (
                <Card className={UCPD.packagesCard} sx={{ minWidth: 275, margin: 2 }}>
                    <CardContent className={UCPD.packagesContent}>
                        <TableContainer className={UCPD.tableContainer} component={Paper}>
                            <Table className={UCPD.table}>
                                <TableHead>
                                    <TableRow className={UCPD.headRow}>
                                        <TableCell className={UCPD.headCellSum}>
                                            <div style={{ display: 'flex', justifyContent: 'start' }}>
                                                <img style={{ height: 'auto', width: '20px' }} src={Package} alt="" />
                                                <p style={{ marginLeft: '1rem' }}>{t('orderDetail.sumOfPackages')}</p>
                                            </div>
                                        </TableCell>
                                        <TableCell className={UCPD.headCellDescription}>
                                            <div style={{ display: 'flex', justifyContent: 'start' }}>
                                                <TextsmsIcon style={{ color: 'orange' }}></TextsmsIcon>
                                                <p style={{ marginLeft: '1rem' }}>{t('orderDetail.description')}</p>
                                            </div>
                                        </TableCell>
                                        <TableCell className={UCPD.headCellBarcode}>
                                            <div style={{ display: 'flex', justifyContent: 'start' }}>
                                                <QrCode2Icon style={{ color: 'orange' }}></QrCode2Icon>
                                                <p style={{ marginLeft: '1rem' }}>{t('orderDetail.packageBarcode')}</p>
                                            </div>
                                        </TableCell>
                                        <TableCell className={UCPD.headCellQty}>
                                            <div style={{ display: 'flex', justifyContent: 'start' }}>
                                                <img style={{ height: 'auto', width: '20px' }} src={Clear} alt="" />
                                                <p style={{ marginLeft: '1rem', marginTop: '0.2rem' }}>
                                                    {t('orderDetail.quantity')}
                                                </p>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.map((row: any, index: any) => (
                                        <TableRow className={UCPD.packageRow} key={index}>
                                            <TableCell className={UCPD.bodyCellSum} style={{ textAlign: 'left' }}>
                                                {row.sumOfPackages}
                                            </TableCell>
                                            <TableCell
                                                className={UCPD.bodyCellDescription}
                                                style={{ textAlign: 'left' }}
                                            >
                                                {row.description}
                                            </TableCell>
                                            <TableCell className={UCPD.bodyCellBarcode} style={{ textAlign: 'left' }}>
                                                {row.packageBarcodeString}
                                            </TableCell>
                                            <TableCell className={UCPD.bodyCellQty} style={{ textAlign: 'left' }}>
                                                {row.quantity}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CardContent>
                </Card>
            ) : cargoLoading ? (
                <Grid
                    className={UCPD.loadingGrid}
                    container
                    style={{ height: '100%' }}
                    alignItems="center"
                    justifyContent="center"
                >
                    <div
                        className={UCPD.loadingInner}
                        style={{
                            textAlign: 'center',
                            position: 'relative',
                            pointerEvents: 'none',
                        }}
                    >
                        <CircularProgress size={80} />
                    </div>
                </Grid>
            ) : (
                <div
                    className={UCPD.emptyState}
                    style={{
                        color: 'orange',
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '2rem',
                    }}
                >
                    <ContactSupportIcon className={UCPD.emptyIcon} style={{ width: '40px', height: 'auto' }} />
                    <h2 className={UCPD.emptyTitle} style={{ marginLeft: '2rem' }}>
                        {t('orderDetail.packageInfoNotFound')}
                    </h2>
                </div>
            )}
        </>
    );
}

export default UserCargoPackageDetails;
